/**
 * Created by tendlich
 * the listview
 */
define(function (require) {
    "use strict";


    var LE = require("app");
    var template = require("connection-templates/ticketTab/extendedList/ticketsGridView.tmpl");
    var emptySearchViewTemplate = require("connection-templates/ticketTab/ticketGridEmptySearchView.tmpl");
    var emptyViewTemplate = require("connection-templates/ticketTab/ticketGridEmptyView.tmpl");
    var TicketsGridRowView = require("connection-views/ticketTab/extendedList/TicketsGridRowView");

    var TicketsGridView = {};

    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {

        TicketsGridView = Marionette.GridView.extend({
            className: "table-main ui-table",
            template: template,
            itemViewContainer: "tbody",
            itemView: TicketsGridRowView,

            initialize: function(options) {
                LEConnection.logger.debug("initialize TicketsGridView", "TicketsGridView:initialize");
            },

            getEmptyView:function(){
                if(this.collection.hasNoTickets){
                    return Marionette.ItemView.extend({
                        template: emptyViewTemplate,
                        className: 'empty-tbl'
                    });
                }else{
                    return Marionette.ItemView.extend({
                        template: emptySearchViewTemplate,
                        className: 'empty-tbl'
                    });
                }
            }
        });
    });

    return TicketsGridView;
});
